/* ============================================================================
   CircleDrops — Share bottom sheet controller (externalized)
   ----------------------------------------------------------------------------
   Save this file as:  assets/share-sheet.js
   Loaded from snippets/share-sheet.liquid with a small inline config bridge
   plus:
     <script src="{{ 'share-sheet.js' | asset_url }}" defer></script>

   DATA BRIDGE: the inline script used ONE Liquid value — the html2canvas asset
   URL ({{ "html2canvas.min.js" | asset_url }}). Shopify does not render Liquid
   in asset .js files, so the Liquid markup sets it on window.__CD_SHARE_ASSETS
   before this file loads, and this file reads it. If it is absent/empty, the
   cdnjs fallback still loads html2canvas.

   Guarded by window.__cdShareInit so it initialises once even though deferred.
   ============================================================================ */

(function () {
  'use strict';
  if (window.__cdShareInit) return;
  window.__cdShareInit = true;

  /* ---------------------------------------------------------------
     CONFIG — brand text lives in share-preview-card.liquid now.
     This only holds share behaviour settings.
  --------------------------------------------------------------- */
  var CD_SHARE_CONFIG = {
    brandName: 'CircleDrops',
    waText: function (d) { return d.title + '\n\nCheck out this find on CircleDrops:'; },
    utm: true,
    /* self-hosted from your theme assets (upload html2canvas.min.js to assets/),
       with an automatic fallback to cdnjs if the asset isn't present */
    html2canvas: (window.__CD_SHARE_ASSETS && window.__CD_SHARE_ASSETS.html2canvas) || '',
    html2canvasFallback: 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js'
  };

  /* option (share row) icons — the preview-card icons live in the template */
  var ICONS = {
    wa:   '<svg viewBox="0 0 32 32" fill="currentColor"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.3.6 4.5 1.8 6.4L4 29l7.9-1.7A12 12 0 1 0 16 3zm0 21.7c-1.9 0-3.7-.5-5.3-1.4l-.4-.2-4.2.9.9-4-.3-.4A9.6 9.6 0 1 1 16 24.7zm5.3-7.2c-.3-.1-1.7-.9-2-1s-.5-.1-.7.2-.8 1-.9 1.2-.3.2-.6.1a7.8 7.8 0 0 1-3.8-3.3c-.3-.5.3-.5.8-1.5.1-.2 0-.4 0-.5s-.7-1.6-.9-2.2-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4a3.4 3.4 0 0 0-1 2.5c0 1.5 1.1 2.9 1.2 3.1s2.1 3.3 5.1 4.6c1.9.8 2.6.9 3.5.8.6-.1 1.7-.7 2-1.4s.3-1.3.2-1.4-.2-.2-.5-.3z"/></svg>',
    fb:   '<svg viewBox="0 0 32 32" fill="currentColor"><path d="M20 10.5h2.2V6.8C21.8 6.7 20.6 6.5 19.2 6.5c-3 0-5 1.8-5 5.1v2.6H11v3.9h3.2V28h4v-9.9h3.1l.5-3.9h-3.6v-2.2c0-1.1.3-1.9 2-1.9z"/></svg>',
    ig:   '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="6" y="6" width="20" height="20" rx="6"/><circle cx="16" cy="16" r="5"/><circle cx="22.2" cy="9.8" r="1.4" fill="currentColor" stroke="none"/></svg>',
    copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>',
    dl:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>'
  };

  var overlay, sheet, currentData = null, isBusy = false;

  function setBusy(b) { isBusy = b; if (overlay) overlay.classList.toggle('cd-busy', b); }

  function getCardMarkup() {
    var tpl = document.getElementById('cd-preview-template');
    if (tpl && tpl.content) {
      var d = document.createElement('div');
      d.appendChild(tpl.content.cloneNode(true));
      return d.innerHTML;
    }
    /* fallback if the template snippet wasn't rendered */
    return '<div class="cd-preview-card" data-cd-card>' +
             '<div class="cd-preview-top"><span class="cd-preview-logo">' + CD_SHARE_CONFIG.brandName + '</span></div>' +
             '<div class="cd-preview-media"><img data-cd-img alt="" crossorigin="anonymous"></div>' +
             '<p class="cd-preview-title" data-cd-title></p>' +
             '<div class="cd-preview-price"><span class="now" data-cd-now></span><span class="was" data-cd-was hidden></span><span class="off" data-cd-off hidden></span></div>' +
           '</div>';
  }

  function optionBtn(action, cls, icon, label) {
    return '<span class="cd-share-option" role="button" tabindex="0" data-share-action="' + action + '">' +
             '<span class="cd-share-option__ic ' + cls + '">' + icon + '</span>' +
             '<span class="cd-share-option__lb">' + label + '</span>' +
           '</span>';
  }

  function hexToRgba(hex, a) {
    var h = (hex || '').replace('#', '');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var n = parseInt(h, 16);
    if (isNaN(n) || h.length !== 6) return 'rgba(22,163,74,' + a + ')';
    return 'rgba(' + ((n>>16)&255) + ',' + ((n>>8)&255) + ',' + (n&255) + ',' + a + ')';
  }

  function buildSheet() {
    overlay = document.createElement('div');
    overlay.className = 'cd-share-overlay';
    overlay.setAttribute('hidden', '');

    overlay.innerHTML =
      '<div class="cd-share-sheet" role="dialog" aria-modal="true" aria-label="Share this listing">' +
        '<span class="cd-share-close" role="button" tabindex="0" aria-label="Close">&times;</span>' +
        getCardMarkup() +
        '<p class="cd-share-heading">Share this listing</p>' +
        '<div class="cd-share-options">' +
          optionBtn('whatsapp', 'cd-ic-wa', ICONS.wa,   'WhatsApp') +
          optionBtn('instagram','cd-ic-ig', ICONS.ig,   'Instagram Story') +
          optionBtn('facebook', 'cd-ic-fb', ICONS.fb,   'Facebook') +
          optionBtn('copy',     'cd-ic-cp', ICONS.copy, 'Copy Link') +
          optionBtn('download', 'cd-ic-dl', ICONS.dl,   'Download') +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    sheet = overlay.querySelector('.cd-share-sheet');

    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSheet(); });

    var closeEl = overlay.querySelector('.cd-share-close');
    closeEl.addEventListener('click', closeSheet);
    closeEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); closeSheet(); }
    });

    overlay.querySelectorAll('.cd-share-option').forEach(function (btn) {
      var run = function () { handleShare(btn.getAttribute('data-share-action')); };
      btn.addEventListener('click', run);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); run(); }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSheet();
    });
  }

  function fill(data) {
    var q = function (sel) { return sheet.querySelector(sel); };

    var img = q('[data-cd-img]');
    if (img) {
      img.onload = null; img.onerror = null;
      img.style.visibility = 'hidden';           /* hide old image until the new one is ready */
      var showImg = function () { img.style.visibility = 'visible'; };
      img.onload = showImg;
      img.onerror = showImg;
      img.crossOrigin = 'anonymous';
      img.alt = data.title || '';
      img.src = data.image || '';
      if (img.complete && img.naturalWidth) showImg();   /* already cached */
    }

    q('[data-cd-title]').textContent = data.title || '';
    q('[data-cd-now]').textContent = data.price || '';

    var brand = q('[data-cd-brand]');
    if (brand) { if (data.brand) { brand.textContent = data.brand; brand.hidden = false; } else { brand.hidden = true; } }

    var was = q('[data-cd-was]'), off = q('[data-cd-off]');
    if (was)  { if (data.compare) { was.textContent = data.compare; was.hidden = false; } else { was.hidden = true; } }
    if (off)  { if (data.discount && parseInt(data.discount, 10) > 0) { off.textContent = data.discount + '% OFF'; off.hidden = false; } else { off.hidden = true; } }

    /* availability pill (top-right) */
    var stockWrap = q('[data-cd-stock]'), stockTxt = q('[data-cd-stock-text]');
    if (stockWrap) {
      if (data.stock) { if (stockTxt) stockTxt.textContent = data.stock; stockWrap.hidden = false; }
      else { stockWrap.hidden = true; }
    }

    /* Brand Size card */
    var bsWrap = q('[data-cd-attr-brandsize]'), bs = q('[data-cd-brandsize]');
    if (bsWrap) {
      if (data.brandSize) { if (bs) bs.textContent = data.brandSize; bsWrap.hidden = false; }
      else { bsWrap.hidden = true; }
    }

    /* Circle Size card */
    var szWrap = q('[data-cd-attr-size]'), sz = q('[data-cd-size]');
    if (szWrap) {
      if (data.size) { if (sz) sz.textContent = data.size; szWrap.hidden = false; }
      else { szWrap.hidden = true; }
    }

    /* Condition card — shaded per condition (colour / bg / border from Liquid) */
    var condWrap = q('[data-cd-attr-cond]'), cond = q('[data-cd-condition]'), condLabel = q('[data-cd-cond-label-el]');
    if (condWrap) {
      if (data.condition) {
        if (cond) cond.textContent = data.condition;
        var c  = data.conditionColor  || '#16a34a';
        var bg = data.conditionBg     || hexToRgba(c, 0.10);
        var bd = data.conditionBorder || hexToRgba(c, 0.35);
        condWrap.style.background  = bg;
        condWrap.style.borderColor = bd;
        if (cond)      cond.style.color      = c;
        if (condLabel) condLabel.style.color = c;
        condWrap.hidden = false;
      } else { condWrap.hidden = true; }
    }

    /* hide the whole attribute row if nothing to show */
    var attrs = q('[data-cd-attrs]');
    if (attrs) {
      var anyAttr = !!(data.brandSize || data.size || data.condition);
      attrs.style.display = anyAttr ? '' : 'none';
    }
  }

  function openSheet(data) {
    currentData = data;
    if (!overlay) buildSheet();
    fill(data);
    overlay.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';   /* lock background scroll (desktop + mobile) */
    document.body.style.overflow = 'hidden';
    document.body.classList.add('cd-share-open');          /* hides the PDP sticky bar while open */
    /* warm up html2canvas in the background so Download/Instagram feels instant */
    if (!window.html2canvas) { try { loadHtml2Canvas(function () {}); } catch (e) {} }
    requestAnimationFrame(function () { requestAnimationFrame(function () { overlay.classList.add('is-open'); }); });
  }

  function closeSheet() {
    if (!overlay) return;
    if (isBusy) return;   /* don't allow closing while the image is being generated */
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.classList.remove('cd-share-open');
    setTimeout(function () { if (!overlay.classList.contains('is-open')) overlay.setAttribute('hidden', ''); }, 300);
  }

  function withUtm(url, source) {
    if (!CD_SHARE_CONFIG.utm) return url;
    try {
      var u = new URL(url);
      u.searchParams.set('utm_source', source);
      u.searchParams.set('utm_medium', 'share');
      return u.toString();
    } catch (e) { return url; }
  }

  /* ---------- PNG export (html2canvas, lazy-loaded) ---------- */
  var _h2cLoading = false, _h2cQueue = [], _h2cTriedFallback = false;
  function _injectH2C(src, onFail) {
    var s = document.createElement('script');
    s.src = src;
    s.onload = function () { var q = _h2cQueue; _h2cQueue = []; q.forEach(function (fn) { fn(); }); };
    s.onerror = onFail;
    document.head.appendChild(s);
  }
  function loadHtml2Canvas(cb) {
    if (window.html2canvas) { cb(); return; }
    _h2cQueue.push(cb);
    if (_h2cLoading) return;
    _h2cLoading = true;
    _injectH2C(CD_SHARE_CONFIG.html2canvas, function () {
      /* self-hosted asset missing/failed -> try cdnjs once */
      if (!_h2cTriedFallback && CD_SHARE_CONFIG.html2canvasFallback) {
        _h2cTriedFallback = true;
        _injectH2C(CD_SHARE_CONFIG.html2canvasFallback, function () {
          _h2cLoading = false; var q = _h2cQueue; _h2cQueue = []; q.forEach(function (fn) { fn(); });
        });
      } else {
        _h2cLoading = false; var q = _h2cQueue; _h2cQueue = []; q.forEach(function (fn) { fn(); });
      }
    });
  }

  function slugify(s) {
    return (s || 'circledrops').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'circledrops';
  }

  function downloadCardImage(msg) {
    var card = sheet && sheet.querySelector('.cd-preview-card');
    if (!card) return;
    setBusy(true);
    toast('Preparing image…', true);   /* persistent while generating */

    /* capture the logo's REAL on-screen size — html2canvas mis-sizes an <img>
       with height set + width:auto, so we pin exact px onto the export clone */
    var liveLogo = sheet.querySelector('.cd-preview-logo-img');
    var logoRect = liveLogo ? liveLogo.getBoundingClientRect() : null;

    loadHtml2Canvas(function () {
      if (!window.html2canvas) { setBusy(false); toast('Could not load image tool'); return; }
      html2canvas(card, {
        backgroundColor: '#ffffff',
        scale: Math.min(3, Math.max(2, window.devicePixelRatio || 2)),  /* match the device: sharp, not wasteful */
        useCORS: true,
        imageTimeout: 5000,    /* don't hang if an image is slow/blocked */
        logging: false,
        /* CRITICAL: only clone the card (its subtree + its ancestors), but ALWAYS
           keep stylesheets/head so the card keeps its CSS in the export. Without
           the card-only limit, html2canvas re-downloads every image on the page
           (banners, product grid, ...); without the style exception, the card
           renders unstyled. This keeps both correct. */
        ignoreElements: function (el) {
          var tag = el.nodeName;
          if (tag === 'STYLE' || tag === 'LINK' || tag === 'HEAD') return false;
          return !(el === card || card.contains(el) || el.contains(card));
        },
        onclone: function (clonedDoc) {
          /* show the FULL title in the exported image (on-screen stays clamped) */
          var t = clonedDoc.querySelector('.cd-preview-title');
          if (t) {
            t.style.whiteSpace = 'normal';
            t.style.overflow = 'visible';
            t.style.textOverflow = 'clip';
            t.style.display = 'block';
            t.style.webkitLineClamp = 'unset';
          }
          /* pin the logo to its on-screen pixel size so it doesn't blow up */
          var cl = clonedDoc.querySelector('.cd-preview-logo-img');
          if (cl && logoRect && logoRect.width && logoRect.height) {
            cl.style.width = logoRect.width + 'px';
            cl.style.height = logoRect.height + 'px';
            cl.style.maxWidth = 'none';
            cl.style.maxHeight = 'none';
          }
        }
      }).then(function (canvas) {
        try {
          canvas.toBlob(function (blob) {
            if (!blob) { setBusy(false); toast('Could not save image'); return; }
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = slugify(currentData && currentData.title) + '-circledrops.png';
            document.body.appendChild(a); a.click(); a.remove();
            setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
            setBusy(false);          /* unlock first so closeSheet can run */
            toast(msg);
            closeSheet();            /* auto-close once downloaded */
          }, 'image/png');           /* PNG: lossless, keeps full image quality */
        } catch (err) { setBusy(false); toast('Could not save image (image blocked by CORS)'); }
      }).catch(function () { setBusy(false); toast('Could not generate image'); });
    });
  }

  function handleShare(action) {
    if (!currentData) return;
    var d = currentData;

    if (action === 'whatsapp') {
      var waUrl = withUtm(d.url, 'whatsapp');
      window.open('https://wa.me/?text=' + encodeURIComponent(CD_SHARE_CONFIG.waText(d) + '\n' + waUrl), '_blank', 'noopener');
      closeSheet();

    } else if (action === 'facebook') {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(withUtm(d.url, 'facebook')),
                  '_blank', 'noopener,width=640,height=640');
      closeSheet();

    } else if (action === 'instagram') {
      downloadCardImage('Image downloaded — you can post it on your Instagram Story');

    } else if (action === 'download') {
      downloadCardImage('Image downloaded');

    } else if (action === 'copy') {
      copyLink(withUtm(d.url, 'copy'), 'Link copied to clipboard');
    }
  }

  function copyLink(url, msg) {
    var done = function () { toast(msg); closeSheet(); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () { legacyCopy(url); done(); });
    } else { legacyCopy(url); done(); }
  }
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  var toastEl, toastTimer;
  function toast(msg, persist) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'cd-share-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-show'); });
    clearTimeout(toastTimer);
    if (!persist) toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3000);
  }

  /* ---------- delegated trigger: works for cards added later too ---------- */
  function triggerFrom(btn) {
    openSheet({
      url:             btn.getAttribute('data-share-url'),
      title:           btn.getAttribute('data-share-title'),
      image:           btn.getAttribute('data-share-image'),
      price:           btn.getAttribute('data-share-price'),
      compare:         btn.getAttribute('data-share-compare'),
      discount:        btn.getAttribute('data-share-discount'),
      brand:           btn.getAttribute('data-share-brand'),
      brandSize:       btn.getAttribute('data-share-brandsize'),
      size:            btn.getAttribute('data-share-size'),
      condition:       btn.getAttribute('data-share-condition'),
      conditionColor:  btn.getAttribute('data-share-condition-color'),
      conditionBg:     btn.getAttribute('data-share-condition-bg'),
      conditionBorder: btn.getAttribute('data-share-condition-border'),
      stock:           btn.getAttribute('data-share-stock')
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cd-share]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    triggerFrom(btn);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var btn = e.target.closest && e.target.closest('[data-cd-share]');
    if (!btn) return;
    e.preventDefault();
    triggerFrom(btn);
  }, true);
})();